module.exports = __webpack_public_path__ + "img/华数传媒logo.629c649e.png";